import * as R from 'ramda';

const copyTo = ({ selectedCategories, college, objectiveCategory, select, setObjectiveCategoryForCollege, removeObjectiveCategoryForCollege, getObjectiveCategoriesForCollege }) => {
  // Si un autre collège (sélectionné) à la même catégorie objective, on sélectionne aussi
  const selectedColleges = R.compose(
    R.keys,
    R.filter(R.propEq('isSelected', true))
  )(selectedCategories);

  R.forEach(selectedCollege => {
    if (selectedCollege !== college) {
      const objectiveCategories = getObjectiveCategoriesForCollege(selectedCollege);
      const identicalObjectiveCategory = R.find(R.eqProps('option', objectiveCategory), objectiveCategories);

      if (!R.isNil(identicalObjectiveCategory)) {
        if (select) {
          setObjectiveCategoryForCollege(selectedCollege, identicalObjectiveCategory);
        } else {
          removeObjectiveCategoryForCollege(selectedCollege);
        }
      }
    }
  })(selectedColleges);
};

export default copyTo;
